import { useEffect, useState } from "react";

import { useAlert, useAuth } from "../../../../providers";
import { useIsMounted } from "../../../../hooks";
import { advertiserService } from "../../../../../infrastructure/services";
import { useLoadingContext } from "../../../../context/loading.context";

const useAdminAdvertisersController = () => {
  const { showError } = useAlert();
  const { user } = useAuth();
  const isMounted = useIsMounted();

  const [advertisers, setAdvertisers] = useState([]);
  const { setLoadingState } = useLoadingContext();

  useEffect(() => {
    if (user != null) {
      setLoadingState(true);
      advertiserService
        .fetchAdvertisers()
        .then((advertisers) => {
          if (isMounted.current) {
            setAdvertisers(advertisers);
          }
        })
        .catch(showError)
        .finally(() => {
          setLoadingState(false);
        });
    }
  }, [user]);

  return { advertisers };
};

export default useAdminAdvertisersController;
